import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData';
import { convertResult } from '../../constants/modals';
import { useModal } from '../../../../../hooks/useModal';
import { defaultStore, stores, useTranslation } from '../../../../../translations';
import { REWARD_VALUE, REWARD_VALUE_KZ } from '../../constants/values';
import { useConvertToCoinsData } from '../../../../../redux/reducer/content';
import useStateControls from '../../../../../hooks/useStateControls';

export function useHandleConvert() {
  const { proportion } = useConvertToCoinsData();
  const { addModal, closeModal } = useModal();
  const { t } = useTranslation();
  const stateCallbacks = useStateControls();

  return useRequestsHandlerData([
    {
      address: 'requestsConvertCoins',
      fulfilled({ profile: { gacha_event_cash: updatedCash } }) {
        closeModal('all');

        addModal(
          convertResult({
            t,
            proportion: proportion,
            rewardValue: defaultStore !== stores.kz ? REWARD_VALUE : REWARD_VALUE_KZ,
            giftsRemain: updatedCash,
            isCanContinue: updatedCash >= proportion,
            customCallbacks: stateCallbacks,
          }),
        );
      },
      rejected() {
        closeModal('all');
      },
    },
  ]);
}
